<template>
  <div class="el-col-24">
    <h5 class="warp-title">修改密码</h5>
    <div class="password-css">
      <el-form ref="ruleFormPassword" :rules="pwRules" :model="pwRuleForm" label-position="top">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input maxlength="12" show-password type="password" v-model.trim="pwRuleForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input maxlength="12" show-password type="password" v-model.trim="pwRuleForm.newPassword"></el-input>
        </el-form-item>
      <div class="red mb15">密码规则为8-12位，且包含数字，字母，符号中的任意两种组合</div>
      </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="passwordBtn('ruleFormPassword')" round :loading="isSubmitLoading">保 存</el-button>
    </span>
    </div>
  </div>
</template>

<script>
import { editUserPwd } from '../../api/order/index'
export default {
  name: 'AmendPassword',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
  },
  data () {
    return {
      isSubmitLoading: false,
      pwRuleForm: {
        oldPassword: '',
        newPassword: ''
      },
      pwRules: {
        oldPassword: [{required: true, min: 8, message: '密码最少8位', trigger: 'change'}],
        newPassword: [{required: true, min: 8, message: '密码最少8位', trigger: 'change'}]
      }
    }
  },
  methods: {
    passwordBtn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.pwRuleForm.newPassword !== this.pwRuleForm.oldPassword) {
            let data = {
              oldPwd: this.pwRuleForm.oldPassword,
              newPwd: this.pwRuleForm.newPassword
            }
            this.isSubmitLoading = true
            editUserPwd(data).then(info => {
              if (info.data.resultCode === 0) {
                this.$refs[formName].resetFields()
                this.$message({
                  message: info.data.resultMessage,
                  type: 'success',
                  onClose: () => {
                    this.$store.dispatch('logout').then(() => {
                      this.$router.push({name: 'Login'})
                    })
                  }
                })
              } else {
                this.$message.error(info.data.resultMessage)
              }
            }).finally(() => {
              this.isSubmitLoading = false
            })
          } else {
            this.$message.error('新密码不可与旧密码相同')
          }
        } else {
          return false
        }
      })
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
a{
  color: #16BB5A;
  text-decoration: underline;
}
.el-button+.el-button{
  margin-left: 0;
}
.el-button--small{
  padding: 9px 10px;
}
.search .el-input.w100{
  width: 100px;
}
.uploadImg{
  margin-top: 10px;
}
.mb15{
  margin-bottom: 15px;
}
.el-col-24{
  font-size: 14px;
}
.password-css{
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Password/Index.vue